module.exports = __webpack_public_path__ + "media/images/business/illust-population-5a60b435e3d6766f227e418a4b716922.svg";